import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Research from "@/pages/Research";
import WordPress from "@/pages/WordPress";
import PostDetail from "@/pages/PostDetail";
import Review from "@/pages/Review";
import ContentHealth from "@/pages/ContentHealth";
import Watchlist from "@/pages/Watchlist";
import UpdateIntel from "@/pages/UpdateIntel";
import ContentIntel from "@/pages/ContentIntel";
import History from "@/pages/History";
import Settings from "@/pages/Settings";
import Finance from "@/pages/Finance";
import EditorialBrain from "@/pages/EditorialBrain";
import Opportunities from "@/pages/Opportunities";
import ExamIntelligence from "@/pages/ExamIntelligence";
import BrainAutomation from "@/pages/BrainAutomation";
import Students from "@/pages/Students";
import TestStudents from "@/pages/TestStudents";
import ChiefEditor from "@/pages/ChiefEditor";
import Ezap2027 from "@/pages/Ezap2027";
import DailyResults from "@/pages/DailyResults";
import SubscribeEmbed from "@/pages/SubscribeEmbed";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null)
    return <div className="flex min-h-screen items-center justify-center text-slate-500">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <Toaster position="bottom-right" richColors />
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/embed/subscribe" element={<SubscribeEmbed />} />
            <Route
              element={
                <Protected>
                  <Layout />
                </Protected>
              }
            >
              <Route path="/" element={<Dashboard />} />
              <Route path="/research" element={<Research />} />
              <Route path="/wordpress" element={<WordPress />} />
              <Route path="/wordpress/post/:id" element={<PostDetail />} />
              <Route path="/review" element={<Review />} />
              <Route path="/content-health" element={<ContentHealth />} />
              <Route path="/watchlist" element={<Watchlist />} />
              <Route path="/update-intel" element={<UpdateIntel />} />
              <Route path="/content-intel" element={<ContentIntel />} />
              <Route path="/history" element={<History />} />
              <Route path="/settings" element={<Settings />} />
              <Route path="/finance" element={<Finance />} />
              <Route path="/brain" element={<EditorialBrain />} />
              <Route path="/opportunities" element={<Opportunities />} />
              <Route path="/exam-intelligence" element={<ExamIntelligence />} />
              <Route path="/brain-automation" element={<BrainAutomation />} />
              <Route path="/students" element={<Students />} />
              <Route path="/test-students" element={<TestStudents />} />
              <Route path="/ezap-2027" element={<Ezap2027 />} />
              <Route path="/chief-editor" element={<ChiefEditor />} />
              <Route path="/daily-results" element={<DailyResults />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
